export function dropdown(ctx) {
    return {
        styles: {
            main: { ...ctx.pretty, radius: 8, text_font: 32, text_color: ctx.COLOR_BG_TEXT, padding: 0 },
            item_buttons: {
                bg_color:     ctx.COLOR_BG,
                border_color: ctx.COLOR_BG_BORDER,
                border_width: 2,
                radius:       8,
                text_color:   ctx.COLOR_BG_TEXT,
                padding:      0,
            },
            selected: { bg_color: ctx.primary },
        },
    };
}
